import { useState } from "react";
import { RefreshCw, MessageCircle } from "lucide-react";
import { client, fmtDate, WA_STATES } from "@/lib/api";

export function WhatsAppLog({ items, onChange, ready, compact }) {
  const [busy, setBusy] = useState("");
  async function retry(id) {
    setBusy(id);
    try { await client.post(`/admin/whatsapp/${id}/retry`); onChange && onChange(); } catch (e) { alert(e.response?.data?.detail || "Yeniden gönderilemedi"); } finally { setBusy(""); }
  }
  return <div className="email-log" data-testid="whatsapp-log">
    {!ready && <div className="notice" data-testid="whatsapp-key-notice">Twilio WhatsApp API <b>kapalı</b> (varsayılan). Otomatik mesaj gönderilmez ve yeni kuyruk kaydı oluşmaz. Müşteriye mesaj göndermek için sipariş detayındaki <b>manuel WhatsApp</b> akışını kullanın. API'yi Ayarlar sekmesinden açabilirsiniz.</div>}
    {(items || []).length === 0 && <p className="muted" data-testid="whatsapp-log-empty">Henüz WhatsApp bildirimi yok.</p>}
    {(items || []).length > 0 && <table><thead><tr>{!compact && <th>Sipariş</th>}<th>Alıcı</th><th>Mesaj</th><th>Durum</th><th>Zaman</th><th></th></tr></thead><tbody>
      {(items || []).map(w => <tr key={w.id} data-testid={`whatsapp-row-${w.id}`}>
        {!compact && <td><strong>{w.order_no}</strong></td>}
        <td>{w.to || "—"}</td>
        <td><MessageCircle size={13} /> <small style={{ display: "inline" }}>{(w.body || "").split("\n").filter(Boolean)[1] || "Kargo bildirimi"}</small></td>
        <td><span className={`pill ${w.state}`} data-testid={`whatsapp-state-${w.id}`}>{WA_STATES[w.state] || w.state}</span>{w.error && <small title={w.error}>{w.error.slice(0, 60)}</small>}</td>
        <td>{fmtDate(w.sent_at || w.created_at)}</td>
        <td>{w.state !== "sent" && !!w.to && <button className="icon-btn small" disabled={busy === w.id} onClick={() => retry(w.id)} title="Yeniden gönder" data-testid={`whatsapp-retry-${w.id}`}><RefreshCw size={13} /></button>}</td>
      </tr>)}
    </tbody></table>}
  </div>;
}
